import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiFirebase,
  SiNextdotjs,
  SiPostgresql,
  SiTypescript,
  SiAndroid,
  SiIos,
} from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";
import { StaggerContainer, StaggerItem } from "../AnimatedSection";
import TechIconCard from "./TechIconCard";

const skills = [
  { icon: <SiAndroid />, key: "android", name: "Android" },
  { icon: <SiIos />, key: "ios", name: "iOS" },
  { icon: <DiJavascript1 />, key: "js", name: "JavaScript" },
  { icon: <SiTypescript />, key: "ts", name: "TypeScript" },
  { icon: <DiNodejs />, key: "node", name: "Node.js" },
  { icon: <DiReact />, key: "react", name: "React" },
  { icon: <TbBrandReactNative />, key: "react-native", name: "React Native" },
  { icon: <SiNextdotjs />, key: "next", name: "Next.js" },
  { icon: <DiMongodb />, key: "mongo", name: "MongoDB" },
  { icon: <DiGit />, key: "git", name: "Git" },
  { icon: <SiFirebase />, key: "firebase", name: "Firebase" },
  { icon: <SiPostgresql />, key: "postgres", name: "PostgreSQL" },
  { icon: <DiJava />, key: "java", name: "Java" },
];

function Techstack() {
  return (
    <StaggerContainer>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        {skills.map((skill) => (
          <Col xs={4} md={2} key={skill.key}>
            <StaggerItem>
              <TechIconCard icon={skill.icon} name={skill.name} />
            </StaggerItem>
          </Col>
        ))}
      </Row>
    </StaggerContainer>
  );
}

export default Techstack;
